import { useState } from 'react';
import { ContentStyle } from './style';

type SelectItemModalProps = {
    onClick: (value: string) => void,
    name: string,
    url: string,
}

export default function SelectItemModalProps({
  name, url, onClick,
}:SelectItemModalProps): JSX.Element {
  const [onHover, setHover] = useState(false);

  return (
    <div
      key={ name }
      onClick={ () => onClick(url) }
      style={ onHover ? ContentStyle.imageContainerHover : ContentStyle.imageContainerWhite }
    >
      <img
        onMouseEnter={ () => setHover(true) }
        onMouseLeave={ () => setHover(false) }
        width={ 36 }
        src={ url }
        srcSet={ url }
        alt={ name }
        title={ name }
        loading="lazy"
        style={ ContentStyle.image }
      />
    </div>
  );
}
